/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';
import finditLogo from 'assets/images/findit-twc-40x40.webp';
import roamLogo from 'assets/images/roam-logo-twc.webp';
import gunTradersLogo from 'assets/images/gun-traders-twc-40x40.webp';
/**
 * Style dependencies
 */
import './styles.scss';

const ConnectionTypeTag = ({ connectionType, className }) => {
	const classes = classnames('connection-type-tag', className, '--type-' + connectionType);
	let icon = null;

	switch (connectionType) {
		case 'shopify':
		case 'shopify_graphql':
			icon = <Icon type='fa' name='FaShopify' />;
			break;
		case 'magento':
			icon = <Icon type='fa' name='FaMagento' />;
			break;
		case 'woo_commerce':
			icon = <Icon type='si' name='SiWoo' />;
			break;
		case 'big_commerce':
			icon = <Icon type='si' name='SiBigcommerce' />;
			break;
		case 'findit':
			//icon = <Icon type='md' name='MdLocationOn' />
			icon = <img src={finditLogo} alt='Tower Systems' height={30} width={30} />;
			break;
		case 'roam':
			//icon = <Icon type='md' name='MdLocationOn' />
			icon = <img src={roamLogo} alt='Tower Systems' height={30} width={30} />;
			break;	
	    case 'gun_traders':
			//icon = <Icon type='md' name='MdLocationOn' />
			icon = <img src={gunTradersLogo} alt='Tower Systems' height={30} width={30} />;
			break;
		default:
			icon = null;
	}

	return <Box className={classes}>{icon}</Box>;
};

export default ConnectionTypeTag;
